import { useContext, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DataContext } from "../../context/DataContext";
import { adminPost } from "./adminApi";
import { consoleColors, primaryButtonSx } from "./consoleTheme";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { setAdminData } = useContext(DataContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!username.trim() || !password.trim()) {
      toast.error("Username and password are required");
      return;
    }
    setLoading(true);
    try {
      const result = await adminPost("ADMIN_LOGIN", { username: username.trim(), password: password.trim() });
      if (result.status === "200" && result.data?.admin_info) {
        setAdminData(result.data);
        sessionStorage.setItem("adminData", JSON.stringify(result.data));
        toast.success("Welcome back");
        navigate("/console/home");
      } else {
        toast.error(result?.data?.error || result?.status_message || "Invalid username or password");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", background: "#fff" }}>
      <Box sx={{ display: { xs: "none", md: "flex" }, width: "46%", background: consoleColors.sidebar, color: "#fff", flexDirection: "column", justifyContent: "space-between", p: 6 }}>
        <Box>
          <Typography sx={{ letterSpacing: 1.6, fontSize: 13, color: consoleColors.gold, fontWeight: 700 }}>CASHI</Typography>
          <Typography sx={{ fontSize: 40, fontWeight: 700, lineHeight: 1.15, mt: 8, maxWidth: 420 }}>
            Store console for licences, offers, and reports.
          </Typography>
        </Box>
        <Typography sx={{ color: consoleColors.navText, fontSize: 14 }}>Internal use</Typography>
      </Box>

      <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", p: 3, background: consoleColors.page }}>
        <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%", maxWidth: 400, background: "#fff", border: `1px solid ${consoleColors.line}`, borderRadius: 3, p: 4 }}>
          <Typography sx={{ fontSize: 13, color: consoleColors.muted, fontWeight: 700, letterSpacing: 0.6 }}>CONSOLE</Typography>
          <Typography sx={{ fontSize: 28, fontWeight: 700, color: consoleColors.ink, mt: 0.5, mb: 3 }}>Sign in</Typography>
          <TextField fullWidth label="Username" value={username} onChange={(e) => setUsername(e.target.value)} sx={{ mb: 2 }} />
          <TextField fullWidth label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <Button type="submit" fullWidth disabled={loading} variant="contained" sx={{ ...primaryButtonSx, mt: 3, py: 1.2 }}>
            {loading ? "Signing in..." : "Sign in"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
